// extracted by mini-css-extract-plugin
export default {"activeLink":"styles_activeLink__DJ4c4","wrapper":"styles_wrapper__OEyEI","label":"styles_label__jkpZb","link":"styles_link__nf3ue","icon":"styles_icon__uNpfL"};